import { renderAsEntity } from "./jsx-entity";
import { addComponent } from "bitecs";
import { Networked } from "../bit-components";
import { findAncestorWithComponent } from "./scene-graph";
import { setInitialNetworkedData } from "./assign-network-ids";

/**
 * Mirror behaviour of GLTF snappeable component inflation:
 *  • Spawns an ECS entity with snappeable component (bounds from scale)
 *  • Adds Networked component and assigns deterministic IDs
 *  • Parents resulting object3D under the provided element.
 *
 * @param {HTMLElement} el            A-Frame entity owning the snappeable attribute.
 * @param {Object}      componentData Raw component data from GLTF or Scriptable element.
 */
export function snappeableEcsInit(el, componentData = {}) {
  if (!window.APP?.world || !el?.object3D) return;

  const bounds = componentData.scale || { x: 1, y: 1, z: 1 };

  el.object3D.scriptableType = "snap-collider";

  const entityDef = {
    components: {
      snappeable: { bounds }
    },
    attrs: {},
    children: []
  };

  const eid = renderAsEntity(APP.world, entityDef);

  if (componentData.networkable?.enabled) {
    addComponent(APP.world, Networked, eid);
  }

  const networkedEl = findAncestorWithComponent(el, "networked");
  const rootNid = (networkedEl && networkedEl.components.networked.data.networkId) || "scene";

  const idx = el.object3D.children?.[0]?.userData?.gltfIndex ?? eid;
  setInitialNetworkedData(eid, `${rootNid}.${idx}`, rootNid);

  el.object3D.add(APP.world.eid2obj.get(eid));
}
